var map = {
	"./v1/Play": [
		"AnrR",
		0,
		8
	],
	"./v2/Play": [
		"iriD",
		9
	],
	"./v2/mobile/Play": [
		"DXrX",
		0,
		4,
		1,
		3
	],
	"./v2/web/Play": [
		"TUAE",
		0,
		1,
		2
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(id);
	});
}
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "N6Fi";
module.exports = webpackAsyncContext;